import { FormDataMemberCompanyInquiry } from '@/form/form-data/FormDataMemberCmpanyInquiry';
import MemberCompanyInquiry from '@/entity/MemberCompanyInquiry';
import { memberCompanyInquiryService } from '@/services/member-company-inquiry';
import { defineStore } from 'pinia';
import { MemberCompanyInquiryPost } from '@/service-data/member-company-inquiry/MemberCompanyInquiryPost';
import { computed, ref, } from 'vue';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
/** 초기화 되지 않는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
};
// 회원사 업무문의
export const piniaMemberCompanyInquiry = defineStore('memberCompanyInquiry', () => {
    // state
    /**
     * 검색
     */
    const filterOption = ref({
        pageSizeType: pageSizeEnum['50'],
        pageNumber: 1,
        workerType: '',
        searchType: 'TITLE',
        searchText: '',
    });
    /**
     * 리스트
     */
    const itemList = ref([]);
    /**
     * 상세정보
     */
    const itemDetail = ref(new MemberCompanyInquiry());
    /**
     * 댓글 리스트
     */
    const itemComments = ref([]);
    /**
     * 페이지네이션
     */
    const paginationData = ref({});
    /**
     * 수정, 등록 폼데이터
     */
    const formData = ref(new FormDataMemberCompanyInquiry());
    /**
     * 비교를 위한 원본 데이터
    */
    const originFormData = ref(new FormDataMemberCompanyInquiry());
    /**
     * 게시글 수
     */
    const noticeTotalCount = computed(() => paginationData.value.total || 0);
    /**
     * 템플릿 리스트
    */
    const templates = ref([]);
    /**
       * res to form
       * 폼 데이터로 가공
       */
    const setFormData = (data) => {
        formData.value = new FormDataMemberCompanyInquiry(data);
        originFormData.value = new FormDataMemberCompanyInquiry(data);
    };
    /**
     * 리스트 조회
     */
    const getItemList = async () => {
        const response = await memberCompanyInquiryService.getItemList({
            pageNumber: filterOption.value.pageNumber,
            pageSize: filterOption.value.pageSizeType,
            workerType: filterOption.value.workerType,
            searchType: filterOption.value.searchType,
            searchText: filterOption.value.searchText,
        });
        itemList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
     * 단건 조회
     */
    const getItem = async (id) => {
        const response = await memberCompanyInquiryService.getItem(id);
        const { inquiry, comments } = response; // 응답에서 inquiry와 comments를 분리
        itemDetail.value = inquiry; // inquiry 데이터를 itemDetail에 저장
        itemComments.value = comments || []; // comments 데이터를 별도의 상태로 저장
        return {
            inquiry,
            itemComments,
        };
    };
    /**
     * 단건 등록
     */
    const createItem = async () => {
        const serviceData = new MemberCompanyInquiryPost(formData.value);
        const response = await memberCompanyInquiryService.createItem(serviceData);
        return response;
    };
    /**
     * 단건 삭제
     */
    const deleteItem = async (id) => {
        const response = await memberCompanyInquiryService.deleteItem(id);
        return response;
    };
    /**
       * 단건 수정
       */
    const updateItem = async () => {
        const serviceData = new MemberCompanyInquiryPost(formData.value);
        const response = await memberCompanyInquiryService.updateItem(serviceData);
        return response;
    };
    /**
       * 단건 초기화
       */
    const clear = () => {
        itemDetail.value = new MemberCompanyInquiry();
    };
    /**
     * 필터 옵션 업데이트
     */
    const updateFilterOption = (newOptions) => {
        filterOption.value = {
            ...filterOption.value,
            ...newOptions,
        };
    };
    /**
     * 데이터 초기화 후 새로고침
     */
    const getFilteredData = async () => {
        filterOption.value.pageNumber = 1; // 첫 페이지로 초기화
        await getItemList();
    };
    /**
     * 템플릿 리스트 조회
     */
    const getTempList = async () => {
        const response = await memberCompanyInquiryService.getTempList();
        templates.value = response;
    };
    return {
        itemDetail,
        itemComments,
        filterOption,
        itemList,
        paginationData,
        noticeTotalCount,
        getItemList,
        getItem,
        clear,
        updateFilterOption,
        getFilteredData,
        formData,
        originFormData,
        getTempList,
        templates,
        createItem,
        setFormData,
        deleteItem,
        updateItem,
    };
});
